import { assertInInjectionContext, inject } from '@angular/core';
import { ActivatedRoute, CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthState } from '@tsin-core/states/auth.state';
import { environment } from '@tsin-env/environment';
import { RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { UserRoleEnum } from '@tsin-shared/utils/options';

// const canActivateFn: CanActivateFn = (route, state) => {
//   assertInInjectionContext(canActivateFn);
//   const router: Router = inject(Router);
//   const store: Store = inject(Store);
//   const isLogin = store.selectSnapshot(AuthState.getIsAuthenticated);
//   console.info(`isLogin ${isLogin}, will activate`);
//   const urlSegment = getLastUrlSlug(route, state);

//   console.log('URL SEGMENT', urlSegment);
//   if (isLogin) {
//     return true;
//   }

//   window = environment.userMgtCreateUrl + '';
//   return router.parseUrl('/account/validate-login');
//   return false;
// };

const canActivateFn: CanActivateFn = (route, state) => {
    assertInInjectionContext(canActivateFn);

    const router: Router = inject(Router);
    const store: Store = inject(Store);
    const isLogin = store.selectSnapshot(AuthState.getIsAuthenticated);

    if (!isLogin) {
        const slug = route.queryParamMap.get('slug') || '';
        window.location.href = slug ? `/account/create-account/${slug}` : '/careers';
        return false;
    }

    const user = store.selectSnapshot(AuthState.getCurrentUser);
    const targetUrl = state.url;

    const roleRouteMap: Record<string, string> = {
        hrAdmin: '/management',
        facilitatorAdmin: '/management',
        superAdmin: '/management',
        admin: '/managers',
        financeAdmin: '/finance',
        financeHeadAdmin: '/finance',
        itAdmin: '/IT'
    };

    if (user?.isStaff && user?.staffType !== 'Full Time') {
        if (!targetUrl.startsWith('/user')) {
            return router.parseUrl('/user');
        }
        return true;
    }
    const roles = ['User', 'examAdmin', 'proAdmin', 'learnerAdmin', 'facilitatorAdmin'];
    if (user?.staffType === 'Casual Staff') {
        if (targetUrl.startsWith('/employee')) {
            return true;
        }
        return router.parseUrl('/employee');
    }

    if (roles.includes(user?.role as string) && user?.staffType === 'Full Time') {
        if (targetUrl.startsWith('/employee')) {
            return true;
        }
        return router.parseUrl('/employee');
    }

    const roleHome = roleRouteMap[user?.role as string];
    if (roleHome) {
        if (targetUrl.startsWith(roleHome) || targetUrl.startsWith('/employee')) {
            return true;
        }
        return router.parseUrl(roleHome);
    }

    return router.parseUrl('/user');
};

export const authGuard: CanActivateFn = (route, state) => {
    return canActivateFn(route, state);
};

export function getLastUrlSlug(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): string {
    const segments = state.url.split('/').filter((segment) => segment.length > 0);
    return segments.length ? segments[segments.length - 1] : '';
}
